import axios from "../helpers/axios";
import { partnersConstants as C } from "./constants";

export const getPartners = () => {
    return async (dispatch, getState) => {
        // ✅ читаем правильный слайс (partnerUser), плюс дефолты чтоб не падать
        const {
            page = 0,
            pageSize = 12,
            sort = "createdAtMinus",
            search = "",
        } = getState().partnerUser || {};

        try {
            dispatch({ type: C.GET_PARTNERS_REQUEST });
            const res = await axios.get("/admin/partners", {
                params: { page, pageSize, sort, search },
            });
            if (res.status === 200) {
                dispatch({ type: C.GET_PARTNERS_SUCCESS, payload: res.data });
            } else {
                dispatch({ type: C.GET_PARTNERS_FAILURE });
            }
        } catch (e) {
            dispatch({ type: C.GET_PARTNERS_FAILURE });
        }
    };
};
export const searchPartners = (q) => {
    // Search.jsx ждёт thunk: мы кладём строку в стор и тут же рефетчим список
    return async (dispatch) => {
        await dispatch(setPartnersSearch(q || ""));
        return dispatch(getPartners());
    };
};

export const getPartnersWithSort = (sort) => {
    return async (dispatch) => {
        if (typeof sort === "string" && sort.length) {
            await dispatch(setPartnersSort(sort));
        }
        return dispatch(getPartners());
    };
};

export const setPartnersPage = (page) => ({ type: C.SET_PAGE, payload: page });
export const setPartnersPageSize = (pageSize) => ({ type: C.SET_PAGE_SIZE, payload: pageSize });
export const setPartnersSort = (sort) => ({ type: C.SET_SORT, payload: sort });
export const setPartnersSearch = (search) => ({ type: C.SET_SEARCH, payload: search });
